import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import Discussion from 'flarum/common/models/Discussion';
import LinkedFormFill from '../components/LinkedFormFill';
import Form from '../models/Form';
import isHorizontalLayout from '../utils/isHorizontalLayout';

interface DiscussionFormModalAttrs extends IInternalModalAttrs {
    form: Form
    discussion: Discussion
}

export default class DiscussionFormModal extends Modal<DiscussionFormModalAttrs> {
    className() {
        return 'FormulaireModal FormulaireTheme Modal--large';
    }

    title() {
        return this.attrs.form.title();
    }

    content() {
        return m('.Modal-body', m(LinkedFormFill, {
            form: this.attrs.form,
            linked: this.attrs.discussion,
            floating: false,
            className: isHorizontalLayout('DiscussionEdit') ? 'Formulaire-horizontal-layout' : '',
        }));
    }

    onsubmit(event: Event) {
        // Prevent the page refreshing when typing enter
        // TODO: submit the actual Formulaire form when doing that
        event.preventDefault();
    }
}
